import { Spinner } from '~/components/_tclOverrides/Spinner/Spinner';
import React, { ComponentType, memo } from 'react';

import { RouteShell } from '~/components/_core/RouteViewport/RouteShell';
import { resolveRouteScrollMode } from '~/components/_core/RouteViewport/resolveRouteScrollMode';
import SiteSelection from '~/components/_core/SiteSelection';
import { useSelector } from '~/store';

import Forbidden from './Forbidden';

const LoginComponent: React.FC = () => {
  return <Spinner relativePosition loading transparent />;
};

interface CheckRoleProps {
  Component: ComponentType;
  authorizedRoles: string[];
  redirect?: boolean;
  showSiteSelection?: boolean;
  isNestedRoute?: boolean;
}

const CheckRole: React.FC<CheckRoleProps> = (props) => {
  const { Component, authorizedRoles = [], redirect, showSiteSelection, isNestedRoute = false } = props;
  const { loaded, effectiveRoles } = useSelector(({ user }) => user);
  const hasRole = authorizedRoles.length === 0 || authorizedRoles.some((role: string) => effectiveRoles.includes(role));
  const scrollMode = resolveRouteScrollMode(isNestedRoute);

  const wrapShell = (content: React.ReactNode) => <RouteShell mode={scrollMode}>{content}</RouteShell>;

  if (!loaded) {
    return wrapShell(<LoginComponent />);
  }

  if (!hasRole && redirect) {
    return wrapShell(<Forbidden />);
  }

  if (!hasRole && !redirect) {
    return null;
  }

  if (showSiteSelection) {
    return wrapShell(
      <SiteSelection>
        <Component />
      </SiteSelection>,
    );
  }

  return wrapShell(<Component />);
};

export default memo(CheckRole);
